// eslint-disable-next-line @typescript-eslint/no-unused-expressions
import "./assets/css/bootstrap.min.css";
import "./localisation/i18n";

import { Provider } from "react-redux";
import store from "./store/store";
import ReactDOM from "react-dom/client";
import App from "./App";

import "@popperjs/core";
import { PermissionsProvider } from "./providers/PermissionsProvider";
import "./assets/css/responsive.css";

import "@fontsource/poppins"; // Defaults to weight 400
import "@fontsource/poppins/400.css"; // Specify weight
import "@fontsource/poppins/400-italic.css"; // Specify weight and style
import LoginSessionExpired from "./LoginSessionExpired";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    {(localStorage.getItem("access-token") === "no-access-token") ? (<LoginSessionExpired />) : (<App />)}
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
